import { EntityType } from '$lib/sanity/types';
import groq from 'groq';

export const PageHierarchyItemsFragment = groq`
  "hierarchyItems": *[_type == "${EntityType.PageTree}" && references(^._id)] {
      hierarchy{ hierarchyItems[] {
        _key,
        id,
        parent,
        page->{_id, _type, name, slug},
      }}
    }[0].hierarchy.hierarchyItems
`;
